import React from 'react';

import PendingStep from '../../../images/packager/pending-step.svg?react';
import CurrentStep from '../../../images/packager/current-step.svg?react';
import FinishedStep from '../../../images/packager/finished-step.svg?react';
import { Typography } from '@mui/material';

const steps = [
  { label: 'Packager' },
  { label: 'Delivery' },
  { label: 'Templates' },
];

interface PackagerStepsProps {
  currentStep: number;
  onStepClick?: (stepIndex: number) => void;
  simulateMode?: boolean;
  numberOfChanges?: number;
}

const PackagerSteps: React.FC<PackagerStepsProps> = ({
  currentStep,
  onStepClick,
  simulateMode = false,
  numberOfChanges = 0,
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      {simulateMode && (
        <Typography
          variant="caption"
          sx={{
            textAlign: 'center',
            mb: 1,
            color: 'white',
            fontWeight: 600,
            backgroundColor: 'warning.light',
            padding: '4px 8px',
            borderRadius: '4px',
          }}
        >
          {`SIMULATE MODE - (${numberOfChanges} changes queued)`}
        </Typography>
      )}
      <div style={{ display: 'flex', width: '100%' }}>
        {steps.map((step, idx) => (
          <div
            key={step.label}
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'flex-start',
              minWidth: 0,
              cursor: onStepClick ? 'pointer' : 'default',
            }}
            onClick={() => onStepClick?.(idx + 1)}
          >
            {idx < currentStep - 1 ? (
              <FinishedStep style={{ width: '100%', height: 'auto', display: 'block' }} />
            ) : idx === currentStep - 1 ? (
              <CurrentStep style={{ width: '100%', height: 'auto', display: 'block' }} />
            ) : (
              <PendingStep style={{ width: '100%', height: 'auto', display: 'block' }} />
            )}
            <div
              style={{
                color: idx === currentStep - 1 ? '#336b8b' : '#9A9FAD',
                fontWeight: idx === currentStep - 1 ? 600 : 400,
                fontSize: 13,
                textAlign: 'center',
                marginTop: 15,
              }}
            >
              {step.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PackagerSteps;
